
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.844 14.575v-3.949l4.34 4.439c.194.198.365.353.513.46h0l.003.003c.173.118.392.172.648.172.3 0 .543-.076.71-.247a.84.84 0 00.24-.65c-.01-.259-.138-.499-.362-.718L9.797 9.792l3.926-3.97h0c.185-.189.294-.4.317-.633a.756.756 0 00-.174-.619c-.148-.188-.392-.27-.7-.27-.216 0-.415.045-.592.136-.174.089-.345.22-.512.392h0L7.844 9.157V5.41c0-.351-.085-.633-.271-.827-.187-.194-.46-.283-.801-.283-.34 0-.614.089-.801.283-.187.194-.271.476-.271.827v9.165c0 .356.084.642.27.838.187.197.461.287.802.287.34 0 .614-.09.801-.287.187-.197.27-.482.27-.838z","fill":"#fff","stroke":"#fff","stroke-width":".2"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16 2H4a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V4a2 2 0 00-2-2zM4 0a4 4 0 00-4 4v12a4 4 0 004 4h12a4 4 0 004-4V4a4 4 0 00-4-4H4z","fill":"#fff"}})])
          )
        }
      }
    